import { PropsWithChildren } from 'react'
import { Link } from 'react-router-dom'
import { useWhiteLabelContext } from '../../../../WhiteLabelContext'

interface Props extends PropsWithChildren {
  selected: boolean
  to: string
  // Optional hover hooks so a link's destination data can be prefetched
  // (default undefined - existing consumers are unaffected).
  onHoverStart?: () => void
  onHoverEnd?: () => void
}

export default function NavigationBarLink({ selected, to, children, onHoverStart, onHoverEnd }: Props): JSX.Element {
  const {whiteLabel } = useWhiteLabelContext()

  return (
    <Link
      style={{color: selected ? whiteLabel.colorHex : undefined}}
      to={to}
      onPointerEnter={onHoverStart}
      onPointerLeave={onHoverEnd}
      className={`flex justify-center items-center h-full w-[150px] hover:bg-gray-100 text-sm font-medium ${
        selected ? 'text-primary-100' : 'text-gray-600'
      }`}>
      {children}
    </Link>
  )
}
